import { render, staticRenderFns } from "./PrintingPrices.vue?vue&type=template&id=46c58d24&lang=pug"
import script from "./PrintingPrices.vue?vue&type=script&lang=js"
export * from "./PrintingPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports